// The landing of the Microsoft flow: `/auth/callback#access_token=…&token_type=bearer&refresh_token=…
// [&return_to=/path][&new_account=1]` or `#error=<code>` (sculpt-api /login/microsoft/callback). `new_account=1`: this
// sign-in has just created the account.
import type { SsoErrorCode, Tokens } from '../types';

export type CallbackOutcome = { type: 'tokens'; tokens: Tokens; returnTo: string; newAccount: boolean } | { type: 'error'; error: SsoErrorCode } | { type: 'none' };

const SSO_ERRORS: SsoErrorCode[] = ['sso_failed', 'cancelled', 'account_disabled', 'staff_only', 'email_plus_address', 'email_disposable_domain', 'link_mismatch'];

export function parseCallbackHash(hash: string): CallbackOutcome {
  const raw = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!raw) return { type: 'none' };
  const params = new URLSearchParams(raw);
  const error = params.get('error');
  if (error) return { type: 'error', error: (SSO_ERRORS as string[]).includes(error) ? (error as SsoErrorCode) : 'sso_failed' };
  const access = params.get('access_token');
  if (!access) return { type: 'none' };
  return {
    type: 'tokens',
    tokens: { access_token: access, token_type: params.get('token_type') || 'bearer', refresh_token: params.get('refresh_token') },
    returnTo: safeReturnTo(params.get('return_to')),
    newAccount: params.get('new_account') === '1',
  };
}

/** A path inside the app, never a URL (the API already enforces it; this is the client's belt): "/x", never "//host"
 *  nor "/\host" (browsers read a backslash as a slash), and no tab or newline, which browsers drop from a URL
 *  ("/<tab>/host" is "//host"). React Router's GHSA-wrjc-x8rr-h8h6 is that open redirect. */
export function safeReturnTo(value: string | null | undefined): string {
  if (!value || !/^\/(?![/\\])[^\\\t\n\r]*$/.test(value)) return '/';
  return value;
}
